import { eventBus } from '@/main.js'

export default {
  data () {
    return {
      resizeTimeout: null
    }
  },
  methods: {
    handleResize () {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(() => {
        if (this.isMobile) {
          if (this.isIphone() && this.fullScreenActive) {
            this.iOSHandleResize()
            eventBus.onVideoPositioning()
            return
          }
        }
        eventBus.onVideoPositioning()

        this.asideHeight()

        this.modalOnMobileLandscape()
      }, 100)
    },
    iOSHandleResize () {
      eventBus.onComponentsVisibility(false)
      eventBus.onGameScrollLock('true')
    },
    asideHeight () {
      if (window.innerWidth > 1100) {
        if (this.elementAside) {
          this.elementAside.style.height = this.getOffset(this.elementAside).top + 50 + 'px'
        }
      } else {
        if (this.elementAside) {
          this.elementAside.style.height = ''
        }
      }
    },
    getOffset (el) {
      const rect = el.getBoundingClientRect()
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      }
    }
  }
}
